export default "__VITE_ASSET__8f34e0e5__"